import { useLocation, useNavigate, useParams } from "react-router-dom";
import { languages, normalizeLang, switchLangPath } from "../lib/i18n";

export default function LanguageSwitcher() {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <select className="h-11 rounded-full border border-[rgba(15,23,42,0.08)] bg-white/80 px-3 text-sm shadow-[0_10px_24px_rgba(15,23,42,0.05)]" value={normalizeLang(lang)} onChange={(e) => { localStorage.setItem("lang", e.target.value); navigate(switchLangPath(location.pathname, e.target.value as never)); }}>
      {languages.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}
    </select>
  );
}
